import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatDialogRef, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HorarioService } from '../../../_core/services/horario.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'm-add-edit-asignacion',
  templateUrl: './add-edit-asignacion.component.html',
  styleUrls: ['./add-edit-asignacion.component.scss'],
  providers: [ DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'es' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class AddEditAsignacionComponent implements OnInit {
  viewLoading: boolean = false;
  formMACRO: FormGroup;

  NroPersonal: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddEditAsignacionComponent>,
    private _formBuilder_lote: FormBuilder, 
    private datePipe: DatePipe,
    private horarioService: HorarioService,
    public toastr: ToastrManager,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.create_form();
    this.getHorario_cbo();
    console.log(this.data)
    console.log(this.data.item)
    if (this.data.item.AsignacionHorario > 0) {
      this.loadData();
    }
  }

  create_form(){
    this.formMACRO = this._formBuilder_lote.group({
      DNI: [null, Validators.required],
      NombrePersonal: [null, Validators.required],
      Horario: [null, Validators.required],
      FechaInicio: [null, Validators.required],
      FechaFin: [null, Validators.required],
    });
  }

  loadData() {
    var data = this.data.item;
    var controls = this.formMACRO.controls;

    controls.DNI.setValue(data.CodigoTrabajador);
    controls.NombrePersonal.setValue(data.NombresApellidos);
    this.posible_Horario = data.IdHorario;
    controls.FechaInicio.setValue(data.FechaInicio);
    controls.FechaFin.setValue(data.FechaFin);
    this.NroPersonal = data.NroPersonal;
  }

  //#region COMBOS
  protected _onDestroy = new Subject<void>();
  posible_Horario=null;
  public filterHorario: FormControl = new FormControl();
  public filtered_Horario: ReplaySubject<any> = new ReplaySubject<any>(); 
  array_Horario: any[]=[];
  getHorario_cbo(){
    this.horarioService.ListarHorario().subscribe(
      (data: any) => {
        data=data.filter(e=>e.Activo==true);
        this.array_Horario = data;
        this.filtered_Horario.next(this.array_Horario.slice());
        this.filterHorario.valueChanges.pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtrar_Horario();
          }
        );
        this.formMACRO.controls.Horario.setValue(this.posible_Horario);
      }, ( errorServicio ) => {
        console.log(errorServicio);
      }
    );
  }
  filtrar_Horario(){
    if (this.array_Horario.length==0) {
      return;
    }
    let search = this.filterHorario.value;
    if (!search) {
      this.filtered_Horario.next(this.array_Horario.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtered_Horario.next(
      this.array_Horario.filter(item => item.Nombre.toLowerCase().indexOf(search) > -1)
    );
  }
  //#endregion
  save_update(){
    const _controls = this.formMACRO.controls; 
      if (this.formMACRO.invalid) {
        Object.keys(_controls).forEach(controlName =>
          _controls[controlName].markAsTouched()
        );
        this.toastr.warningToastr('Ingrese los campos obligatorios.', 'Advertencia!', {
          toastTimeout: 2000,
          showCloseButton: true,
          animate: 'fade',
          progressBar: true
        });
      }else{
        this.viewLoading = true;
        let model = {
          prmintAsignacionHorario: this.data.item.AsignacionHorario,
          prmintHorario: _controls.Horario.value,
          prmstrNroPersonal: this.NroPersonal,
          prmdateFechaInicio: this.datePipe.transform(_controls.FechaInicio.value,'yyyy-MM-dd'),
          prmdateFechaFin: this.datePipe.transform(_controls.FechaFin.value,'yyyy-MM-dd')
        };
        
        this.horarioService.SaveUpdateAsignacionHorario(model).subscribe(
          (data: any) => {
            if(data[0].Ok){
              this.toastr.successToastr(data[0].Message, 'Éxito!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });

              this.viewLoading = false;
              this.dialogRef.close(true);
            } else{
              this.toastr.warningToastr(data[0].Message, 'Advertencia!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });

              this.viewLoading = false;
            }
          }, ( errorServicio ) => {
            this.toastr.errorToastr(errorServicio.message, 'Error!', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
            this.viewLoading = false;
            console.log(errorServicio);
          }
        );
          
      }
      return;
  }

  onNoClick(): void {
		this.dialogRef.close();
  }

  onYesClick() {
    this.viewLoading = true;
    this.dialogRef.close(true);
  }

  searchPersonal() {
    if (this.formMACRO.controls.DNI.value == null || this.formMACRO.controls.DNI.value == '') {
      this.toastr.warningToastr('Ingrese el DNI.', 'Advertencia!', {
        toastTimeout: 2000,
        showCloseButton: true,
        animate: 'fade',
        progressBar: true
      });

      this.formMACRO.controls.NombrePersonal.setValue(null);
      this.NroPersonal = '';
    } else {
      this.horarioService.BuscarPersonalByDNI(this.formMACRO.controls.DNI.value).subscribe(
        (data: any) => {
          if (data.length == 0) {
            this.toastr.warningToastr('El Personal buscado no existe.', 'Advertencia!', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });

            this.formMACRO.controls.NombrePersonal.setValue(null);
            this.NroPersonal = '';
          } else {
            this.formMACRO.controls.NombrePersonal.setValue(data[0].Nombres + ' ' + data[0].ApellidoPaterno);
            this.NroPersonal = data[0].NroPersonal;
          }
        }
      )
    }
  }

  getMaxDate() {
    if (this.formMACRO.controls['FechaFin'].value!=null && this.formMACRO.controls['FechaFin'].value!=undefined) {
      return this.formMACRO.controls['FechaFin'].value;
    } else {
      return null;
    }
  }
}